import React, { useState } from 'react';
import { Headings } from '@arctheme-components/elements/Headings/Headings';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import { ProductTile } from '../../../ecommerce/Product/ProductTile';
import ListProductsCTA from '../ListProductsCTA/ListProductsCTA';
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { DosagePopup } from "../DosagePopup";
import { SecondaryCTA } from "../ListProducts";
import { SubscribePopup } from '../SubscribePopup';

export default function ListProductsScrollable({ products, settings }) {
  const {
    section,
    mobile_breakpoint,
    globals: { enable_wishlist },
    product_limit
  } = settings;
  const isMobile = useMobileBreakpoint(mobile_breakpoint);
  let ctaPosition = 'top';
  const [isOpen, setIsOpen] = useState(false);
  const [dosageGuide, setDosageGuide] = useState(false);
  const [isSubscribeOpen, setIsSubscribeOpen] = useState(false);
  const [subscribeProduct, setSubscribeProduct] = useState(null);

  const onClickDosage = (productItem) => {
		const dosage = productItem?.dosage || productItem?.dosage_form;
		if( dosage ) {
			setDosageGuide(productItem)
			setIsOpen(true);
		}
	}

  // Handler to open subscribe popup
  const onClickSubscribe = (productItem) => {
    setSubscribeProduct(productItem);
    setIsSubscribeOpen(true);
  };

  const secondaryCTA = section.secondary_cta_type || SecondaryCTA.DOSAGE;

  settings.show_price = section.product_tile_price_show;
  settings.show_quickadd = section.product_tile_quickadd_show;
  settings.show_tags = section.product_tile_tag_show;

  // Apply product limit if set
  const limitedProducts = product_limit > 0 ? products.slice(0, product_limit) : products;

  if (isMobile) {
    ctaPosition = 'bottom';
  }

  return (
    <div className='product-list scrollable-list'>
      <div className={'section-top'}>
        <div className={'section-bar w-full flex flex-row justify-between mb-[32px]'}>
          <div className={'section-info'}>
            <Headings
              text={section?.title}
              type={section.seo_title_font_type  || 'h5'}
              classes={`${isMobile ? section.header_style_mobile : section.header_style}`}
            />
            <Paragraph
              text={section?.subtext}
              type={section?.subtext_style}
            />
          </div>
          {ctaPosition === 'top' && (
            <ListProductsCTA
              section={section}
              isMobile={isMobile}
            />
          )}
        </div>
      </div>
      <div
        className={'w-full'}
        x-data='carouselFilter()'
      >
        <div className='row-start-1 col-start-1'>
          <div className='carousel-item-container w-full'>
            <div
              x-data='scrollable'
              className='product-list__scrollable w-full flex overflow-x-auto'
            >
              {limitedProducts.map((product, id) => (
                <div
                  key={id}
                  className='carousel-item'
                  x-init='$nextTick(() => { initialise(false, true, false, false) })'
                >
                  <ProductTile
                    product={product}
                    swatches={product?.swatches}
                    type={'slider'}
                    siblings={undefined}
                    settings={settings}
                    onClickDosage={() => onClickDosage(product)}
                    showDosageButton={secondaryCTA == SecondaryCTA.DOSAGE  && (!!product?.dosage || !!product?.dosage_form)}
                    enableWishlist={enable_wishlist}
                    onClickSubscribe={() => onClickSubscribe(product)}
                    showSubscribeButton={secondaryCTA == SecondaryCTA.SUBSCRIBE}
                    noSecondaryButton={secondaryCTA == SecondaryCTA.NONE}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={'section-bottom flex justify-center mt-4'}>
        {ctaPosition === 'bottom' && (
          <ListProductsCTA
            section={section}
            isMobile={isMobile}
          />
        )}
      </div>
      <DosagePopup isOpen={isOpen} setIsOpen={setIsOpen} product={dosageGuide} settings={settings}/>
      {isSubscribeOpen && (
        <SubscribePopup
          isOpen={isSubscribeOpen}
          setIsOpen={setIsSubscribeOpen}
          product={subscribeProduct}
          settings={settings}
          translations={settings.translations}
        />
      )}
    </div>
  );
}
